import { render, staticRenderFns } from "./withdrawal-detail.vue?vue&type=template&id=0ad49714&scoped=true&"
import script from "./withdrawal-detail.vue?vue&type=script&lang=js&"
export * from "./withdrawal-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-detail.vue?vue&type=style&index=0&id=0ad49714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad49714",
  null
  
)

export default component.exports